module.exports = __webpack_public_path__ + "static/media/diktat-20.083fe936.mp3";